module.exports = __webpack_public_path__ + "img/logo.74c786c5.png";